import React, { useState } from "react";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos"
import "./Dictionary.css";

export default function Dictionary(props){
let [Keyword, setKeyword] = useState(props.defaultKeyword);
let [results, setResults] = useState(null);
let [loaded, setLoaded] = useState(false);
let [photos, setPhotos] = useState(null);

function handleResponse(response){
    setResults(response.data[0]);
}

function handlePexelsResponse(response){
    setPhotos(response.data.photos);
}

function search(){
 let apiUrl =`https://api.dictionaryapi.dev/api/v2/entries/en_US/${Keyword}`;
    axios.get(apiUrl).then(handleResponse);
    
    let pexelsApiKey = "563492ad6f917000010000012ec5e5fe01e145fea2220a89eaeef3d2";
    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${Keyword}&per_page=9`;
    let headers = { Authorization: `Bearer ${pexelsApiKey}`}
    axios.get(pexelsApiUrl, { headers: headers }).then(handlePexelsResponse);
    }


function handleSubmit(event){
    event.preventDefault();
    search();
}

    
function handelKeyword(event){
 setKeyword(event.target.value);
}

function load(){
    setLoaded(true);
    search();
}

if (loaded) {
    return(
        <div className="Dictionary">
            <section>
                <h1>What word do you want to look up?</h1>
            <form onSubmit={handleSubmit}>
                <input type="search" onChange={handelKeyword} defaultValue={props.defaultKeyword}/>
            </form>
            <div className="hint">i.e. sunset, wine, yoga, plants</div>
            </section>
            <Results results={results}/>
            <Photos photos={photos}/>
        </div>
    );
  } else {
      load();
      return "Loading...";
  }
}